import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eec1e87e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-16" }
const _hoisted_2 = { class: "d-flex table-responsive" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "fit text-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon icon-trash fw-bold" })
], -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  colspan: "222222",
  class: "empty-state py-8 px-12 text-center"
}
const _hoisted_6 = { class: "h-100 w-100 d-flex flex-column align-items-center justify-content-center text-center" }
const _hoisted_7 = { class: "h5 title text-primary mb-48" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add me-12",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_table_header = _resolveComponent("v-table-header")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_form_row = _resolveComponent("v-form-row")!
  const _component_v_table_body = _resolveComponent("v-table-body")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_table, { class: "table-bordered tableInput" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_table_header, null, {
            default: _withCtx(() => [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lastFormStructure.form_groups, (structureFormGroup, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(structureFormGroup.form_values, (structureFormValue, index) => {
                      return (_openBlock(), _createElementBlock("th", {
                        key: index,
                        class: "text-center"
                      }, _toDisplayString(_ctx.$t(structureFormValue.label)), 1))
                    }), 128))
                  ], 64))
                }), 128)),
                _hoisted_3
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_table_body, null, {
            default: _withCtx(() => [
              (!_ctx.measures || !_ctx.measures.length)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                    _createElementVNode("td", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('No hay medidas.')), 1),
                        (_ctx.can('professional.expedient.form.store'))
                          ? (_openBlock(), _createBlock(_component_v_button, {
                              key: 0,
                              variant: "secondary",
                              class: "btn-icon me-16",
                              "aria-label": _ctx.$t('Añadir nueva medida'),
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('show-form-create-modal')))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_8,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('Añadir nueva medida')), 1)
                              ]),
                              _: 1
                            }, 8, ["aria-label"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.measures, (formArray, index) => {
                    return (_openBlock(), _createBlock(_component_v_form_row, {
                      "input-class": "text-center pe-4",
                      "suffix-class": "text-sm px-4",
                      "form-type": _ctx.formName,
                      "form-structure": _ctx.lastFormStructure,
                      "form-group": formArray.formGroup,
                      "form-id": formArray.form.id,
                      "force-save": _ctx.forceSave,
                      "adjust-input-for-value": false,
                      "action-buttons": { type: 'button', icon: 'done', value: '' },
                      onDeleteFormGroupRequest: _ctx.confirmDeleteFormGroup,
                      onEmitLoadFormsRequested: _ctx.emitLoadExpedientFormsRequestEvent,
                      key: index
                    }, null, 8, ["form-type", "form-structure", "form-group", "form-id", "force-save", "onDeleteFormGroupRequest", "onEmitLoadFormsRequested"]))
                  }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}